export const DocumentsPageRoute = {
  path: '/document',
  load: () => import('./Documents'),
  protected: true,
};
